import styled from '@emotion/styled';
import Button from '@shared/components/core/button/CoreButton';
import { ContentLayout } from '@shared/components/core/text/ContentTypography';

export const FlexColumn = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
    align-items: center;
`;

export const HeaderWrap = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 2rem 2rem 0;
    max-width: 800px;
    width: calc(100% - 3rem);
`;

export const FeaturesWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2rem;
    align-items: center;
`;

export const TitleWrap = styled.div`
    display: inline-block;
`;

export const ContentHeaderWrap = styled(ContentLayout)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding-bottom: 0;
    max-width: 100%;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
`;
export const ProfileHeadingButton = styled(Button)`
    float: right;
    height: min-content;
`;
